import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Button, Row, Col, Table, Input, Label } from "reactstrap";
import axios from "axios";
import Header from "../../../layout/Header/Header";

function ListadoProcesosEntrada() {
  const { user } = useContext(AuthContext);
  const URL_PROCESOS_ENTRADA = process.env.REACT_APP_URL_PROCESOS_ENTRADA;
  const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };

  const [entradas, setEntradas] = useState([]);
  const [busqueda, setBusqueda] = useState("");

  useEffect(() => {
    axios.get(URL_PROCESOS_ENTRADA, { headers })
      .then((res) => {
        const data = (res.data || [])
          .filter((a) => a.is_active === "Si")
          .map((a) => ({
            _id: a._id,
            numero: a.idProcesosEntrada,
            fecha: a.fecha,
            maquilero: a.proveedores?.[0]?.nombre_comercial || "",
            pedido: a.pedidos?.[0]?.idPedido || "",
            salida: a.procesosSalida?.[0]?.idProcesosSalida || "",
            observaciones: a.observaciones,
            piezas: a.totalPiezas || 0,
            faltantes: a.totalPiezasFaltantes || 0,
            segundas: a.totalPiezasSegundas || 0,
            total: a.totalGeneral || 0,
          }))
          .sort((a, b) => (a.numero < b.numero ? 1 : -1));
        setEntradas(data);
      })
      .catch((err) => console.log(err));
  }, []); // eslint-disable-line

  const filtrados = entradas.filter((a) => {
    const t = `${a.numero} ${a.maquilero} ${a.pedido} ${a.salida} ${a.observaciones}`.toLowerCase();
    return t.includes(busqueda.toLowerCase());
  });

  const totalPzs = filtrados.reduce((s, a) => s + a.piezas, 0);
  const totalImp = filtrados.reduce((s, a) => s + a.total, 0);

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_procesos ? (
        <div className="card container col-11">
          <Row>
            <Col md={8}>
              <Button href="/MenuProduccion" className="btn btn-danger" size="sm">Regresar</Button>{" "}
              <Button href="/ProcesosEntradaCreate" className="btn btn-success" size="sm">Nueva Entrada</Button>
            </Col>
            <Col md={4}>
              <Label>Buscar</Label>
              <Input type="text" value={busqueda} onChange={(e) => setBusqueda(e.target.value)} />
            </Col>
          </Row>
          <h3 align="center">Entradas de Maquila</h3>
          <Table size="sm" striped borderless className="table-responsive-xl">
            <thead>
              <tr>
                <th className="tituloTabla">Numero</th>
                <th className="tituloTabla">Fecha</th>
                <th className="tituloTabla">Salida</th>
                <th className="tituloTabla">Maquilero</th>
                <th className="tituloTabla">Pedido</th>
                <th className="tituloTabla" align="right">Recibidas</th>
                <th className="tituloTabla" align="right">Faltantes</th>
                <th className="tituloTabla" align="right">Segundas</th>
                <th className="tituloTabla" align="right">Total</th>
              </tr>
            </thead>
            <tbody>
              {filtrados.map((a) => (
                <tr key={a._id}>
                  <td>{a.numero}</td>
                  <td>{a.fecha}</td>
                  <td>{a.salida}</td>
                  <td>{a.maquilero}</td>
                  <td>{a.pedido}</td>
                  <td align="right">{new Intl.NumberFormat("en-US").format(a.piezas)}</td>
                  <td align="right">{new Intl.NumberFormat("en-US").format(a.faltantes)}</td>
                  <td align="right">{new Intl.NumberFormat("en-US").format(a.segundas)}</td>
                  <td align="right">
                    {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.total)}
                  </td>
                </tr>
              ))}
              <tr>
                <td colSpan="5" align="right"><b>Totales</b></td>
                <td align="right"><b>{new Intl.NumberFormat("en-US").format(totalPzs)}</b></td>
                <td colSpan="2"></td>
                <td align="right"><b>
                  {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(totalImp)}
                </b></td>
              </tr>
            </tbody>
          </Table>
        </div>
      ) : undefined}
    </>
  );
}

export default ListadoProcesosEntrada;
